"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_GAS_DENOM_OVERRIDES = void 0;
exports.DEFAULT_GAS_DENOM_OVERRIDES = {
    "noble-1": "uusdc",
};
//# sourceMappingURL=constants.js.map